import React, { useState, useEffect } from 'react';
import { Row, Col } from 'antd';
import {useLocation} from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import { HashScroll } from "react-hash-scroll";


import '../../assets/css/evento.css';

import { Element } from 'react-scroll';

import logo1 from '../../assets/images/2026/Logos-Botones/IesSeccionMexico.png';
import logo2 from '../../assets/images/2026/Logos-Botones/IesSeccionMonterrey.png';
import logo3 from '../../assets/images/2026/Logos-Botones/ExpoElectrica.png';

import logo_banner from '../../assets/images/2026/Texto_.png';
import btn_registrar from '../../assets/images/2026/Logos-Botones/Boton_Registrate.png'

import logo_banner_en from '../../assets/images/2026/Texto_.png';

import paquete_general from '../../assets/images/2026/Precios/Normal/General.png';
import paquete_general_hover from '../../assets/images/2026/Precios/Normal/General_scroll.png';
import paquete_asociacion from '../../assets/images/2026/Precios/Normal/Asociaciones.png';
import paquete_asociacion_hover from '../../assets/images/2026/Precios/Normal/Asociaciones_scroll.png';
import paquete_miembros from '../../assets/images/2026/Precios/Normal/MiembrosIes.png';
import paquete_miembros_hover from '../../assets/images/2026/Precios/Normal/MiembrosIes_scroll.png';
import paquete_estudiantes from '../../assets/images/2026/Precios/Normal/EstudiantesIes.png';
import paquete_estudiantes_hover from '../../assets/images/2026/Precios/Normal/EstudiantesIes_scroll.png';

import paquete_estudiantes_normal from '../../assets/images/2026/Precios/Normal/Estudiantes.png';
import paquete_estudiantes_normal_hover from '../../assets/images/2026/Precios/Normal/Estudiantes_scroll.png';


import paquete_general_en from '../../assets/images/2026/Precios/Normal/General.png';
import paquete_general_hover_en from '../../assets/images/2026/Precios/Normal/General_scroll.png';
import paquete_asociacion_en from '../../assets/images/2026/Precios/Normal/Asociaciones.png';
import paquete_asociacion_hover_en from '../../assets/images/2026/Precios/Normal/Asociaciones_scroll.png';
import paquete_miembros_en from '../../assets/images/2026/Precios/Normal/MiembrosIes.png';
import paquete_miembros_hover_en from '../../assets/images/2026/Precios/Normal/MiembrosIes_scroll.png';
import paquete_estudiantes_en from '../../assets/images/2026/Precios/Normal/Estudiantes.png';
import paquete_estudiantes_hover_en from '../../assets/images/2026/Precios/Normal/Estudiantes_scroll.png';

import paquete_estudiantes_normal_en from '../../assets/images/2026/Precios/Normal/Estudiantes.png';
import paquete_estudiantes_hover_normal_en from '../../assets/images/2026/Precios/Normal/Estudiantes_scroll.png';


import paquete_grupal_1 from '../../assets/images/2026/Precios/grupales/4Pack_combinado.png';
import paquete_grupal_1_hover from '../../assets/images/2026/Precios/grupales/4Pack_combinado_scroll.png';
import paquete_grupal_2 from '../../assets/images/2026/Precios/grupales/9Pack_combinado.png';
import paquete_grupal_2_hover from '../../assets/images/2026/Precios/grupales/9Pack_combinado_scroll.png';
import paquete_grupal_3 from '../../assets/images/2026/Precios/grupales/3Estudiantes_combinado.png';
import paquete_grupal_3_hover from '../../assets/images/2026/Precios/grupales/3Estudiantes_combinado_scroll.png';
import paquete_grupal_4 from '../../assets/images/2026/Precios/grupales/3EstudiantesIes_combinado.png';
import paquete_grupal_4_hover from '../../assets/images/2026/Precios/grupales/3EstudiantesIes_combinado_scroll.png';


import AcercaDe from './AcercaDe';
import CarouselPanel from './CarouselPanel';
import CarouselPonentes2 from '../ponentes/CarouselPonentes2';
import Agenda2 from './Agenda2';


const paquetes = [
  {id_paquete:'1',url_imagen_hover:paquete_general_hover,url_imagen:paquete_general,url_imagen_hover_en:paquete_general_hover_en,url_imagen_en:paquete_general_en,nombre:'',link:'/registro/1'},
  {id_paquete:'2',url_imagen_hover:paquete_asociacion_hover,url_imagen:paquete_asociacion,url_imagen_hover_en:paquete_asociacion_hover_en,url_imagen_en:paquete_asociacion_en,nombre:'',link:'/registro/2'},
  {id_paquete:'3',url_imagen_hover:paquete_miembros_hover,url_imagen:paquete_miembros,url_imagen_hover_en:paquete_miembros_hover_en,url_imagen_en:paquete_miembros_en,nombre:'',link:'/registro/3'},
  {id_paquete:'4',url_imagen_hover:paquete_estudiantes_normal_hover,url_imagen:paquete_estudiantes_normal,url_imagen_hover_normal_en:paquete_estudiantes_hover_normal_en,url_imagen_en:paquete_estudiantes_normal_en,nombre:'',link:'/registro/4'},
  {id_paquete:'5',url_imagen_hover:paquete_estudiantes_hover,url_imagen:paquete_estudiantes,url_imagen_hover_en:paquete_estudiantes_hover_en,url_imagen_en:paquete_estudiantes_en,nombre:'',link:'/registro/5'},
]

const paquetes_grupales = [
  {id_paquete:'1',url_imagen_hover:paquete_grupal_1_hover,url_imagen:paquete_grupal_1,url_imagen_hover_en:paquete_grupal_1,url_imagen_en:paquete_grupal_1_hover,nombre:'',link:'mailto:enlace@iesmexico.org?subject=Inscripción%204%20pack&body=Hola%20me%20interesa%20adquirir%20mi%20paquete'},
  {id_paquete:'2',url_imagen_hover:paquete_grupal_2_hover,url_imagen:paquete_grupal_2,url_imagen_hover_en:paquete_grupal_2,url_imagen_en:paquete_grupal_2_hover,nombre:'',link:'mailto:enlace@iesmexico.org?subject=Inscripción%209%20pack&body=Hola%20me%20interesa%20adquirir%20mi%20paquete'},
  {id_paquete:'3',url_imagen_hover:paquete_grupal_3_hover,url_imagen:paquete_grupal_3,url_imagen_hover_en:paquete_grupal_3,url_imagen_en:paquete_grupal_3_hover,nombre:'',link:'mailto:enlace@iesmexico.org?subject=Inscripción%203%20estudiantes&body=Hola%20me%20interesa%20adquirir%20mi%20paquete'},
  {id_paquete:'4',url_imagen_hover:paquete_grupal_4_hover,url_imagen:paquete_grupal_4,url_imagen_hover_normal_en:paquete_grupal_4,url_imagen_en:paquete_grupal_4_hover,nombre:'',link:'mailto:enlace@iesmexico.org?subject=Inscripción%203%20estudiantes%20IES&body=Hola%20me%20interesa%20adquirir%20mi%20paquete'},
]

function onChange(a, b) {
  console.log(a, b);
}


const Evento = (props) =>{
  const [hover_imagen, setHoverImagen] = useState([false,false,false,false]);
  const [select_imagen, setSelectImagen] = useState([false,false,false,false]);
  const [paquete_elegido, setPaqueteElegido] = useState(1);
  const [ver_paquete, setVerPaquete] = useState(false);
  const [ver_paquete_2, setVerPaquete2] = useState(false);
  const location = useLocation();
  const [ver_modal, setVerModal] = useState(true);

  const {idioma} = props;

  const cambiarHoverImagen = (index) =>{

    let arreglo = [];
    for(let i=0; i < 5; i++){
      if(i === index){
        arreglo[i]=true;
      }else{
        arreglo[i]=false;
      }
    }
    console.log(arreglo);
    setSelectImagen(arreglo);
  }
  useEffect(()=>{console.log(hover_imagen)},[hover_imagen]);
  let ver_paquetes = paquetes.map((objeto,index)=>{
      
    return(
      <Col span={4}>
        <Link to={objeto.link}>
        <p onMouseEnter={()=>setVerPaquete(objeto.id_paquete)} onMouseLeave={()=>setVerPaquete(false)}>
          {idioma === 'es' ?
            <img src={ver_paquete === objeto.id_paquete ? objeto.url_imagen_hover : objeto.url_imagen} alt={objeto.nombre} style={{width:'100%', cursor:'pointer'}} />
            :
            <img src={ver_paquete === objeto.id_paquete ? objeto.url_imagen_hover_en : objeto.url_imagen_en} alt={objeto.nombre} style={{width:'100%', cursor:'pointer'}} />
          }
        </p>
        </Link>
      </Col>
    )
  });
  let ver_paquetes_movil = paquetes.map((objeto,index)=>{
    
    return(
      <Col span={10}>
        <Link to={objeto.link}>
        <p onClick={()=>{cambiarHoverImagen(index); setPaqueteElegido(objeto.id_paquete); }} >
          {idioma === 'es' ?
            <img src={select_imagen[index] ? objeto.url_imagen_hover : objeto.url_imagen} alt={objeto.nombre} style={{width:'100%', cursor:'pointer'}} />
          :
          <img src={select_imagen[index] ? objeto.url_imagen_hover_en : objeto.url_imagen_en} alt={objeto.nombre} style={{width:'100%', cursor:'pointer'}} />
          }
        </p>
        </Link>
      </Col>
    )
  });

  let ver_paquetes_gurpales = paquetes_grupales.map((objeto,index)=>{
      
    return(
      <Col xs={12} md={4}>
        <a href={objeto.link}>
        <p onMouseEnter={()=>setVerPaquete2(objeto.id_paquete)} onMouseLeave={()=>setVerPaquete2(false)}>
          <img src={ver_paquete_2 === objeto.id_paquete ? objeto.url_imagen_hover : objeto.url_imagen} alt={objeto.nombre} style={{width:'100%', cursor:'pointer'}} />
        </p>
        </a>
      </Col>
    )
  });

  return(
    <>
    
    <Row justify="center" align="middle">
      <Col xs={0} md={24} className="principal">
        <Row>
          <Col span={8} offset={8}>
            <Row justify={'center'}>
              <Col xs={8}>
                <img src={logo1} width="100%" alt="Logo" />
              </Col>
              <Col xs={8}>
                <img src={logo2} width="100%" alt="Logo" />
              </Col>
              <Col xs={8}>
                <img src={logo3} width="100%" alt="Logo" />
            
              </Col>
            </Row>
          </Col>
          <Col span={10} offset={7}>
             <img src={logo_banner} width="100%" alt="Logo" />
             <br />
             <Link to="#registro" className=''><img src={btn_registrar} alt='registrar' width={'300px'} /></Link>
          </Col>
          <Col span={12} offset={6}  style={{display:'none'}}>
           {idioma === 'es' ?
            <p className="titulo">
            El Seminario de la IES Mexico, es un evento educativo donde se difunden las últimas tendencias y adelantos tecnológicos en el mundo de la iluminación, abordando estos temas desde una perspectiva técnica o de diseño.
            </p>
            :
            <p className="titulo">
            
            </p>

           }
          </Col>
          <Col span={10} offset={7}  style={{display:'none'}}>
            <p className='fecha_banner'>27 y 28 DE MAYO 2026</p>
            <p className='lugar_banner'>Expo Santa Fe, CDMX</p>
          </Col>
          <Col span={4} offset={10} style={{display:'none'}}>
            <br /><br />
            <Link to="#registro" className='btn_registrate_home'>REGÍSTRATE</Link>
          </Col>
        </Row>
      </Col>
      <Col xs={24} md={0} className="principal_movil">
        <Row>
          <Col span={16} offset={4}>
          
          {idioma === 'es' ?
            <img src={logo_banner} width="100%" />
            :
            <img src={logo_banner_en} width="100%" />
            }
           <br />
             <Link to="#registro" className=''><img src={btn_registrar} alt='registrar' width={'150px'} /></Link>
          </Col>
          <Col span={12} offset={6} style={{display:'none'}}>
          <p className='fecha_banner'>27 y 28 DE MAYO 6</p>
            <p className='lugar_banner'>Expo Santa Fé</p>
          </Col>
        </Row>
      </Col>
      </Row>
      <Row id="registro">
      <Element name="#registro" />
        <Col xs={{span:24, offset:0}} md={{span:24, offset:0}} className='paquetes_back' style={{display:'non'}}>
          <Row justify="center">
            <Col xs={24} md={12}>
              <p className='titulo_seccion inter'>ELIGE TU TIPO DE REGISTRO</p>
              <p className='titulo_paquete inter'>PAQUETES INDIVIDUALES</p>
            </Col>
            <Col xs={0} md={24}>
              <Row justify="center">
                {ver_paquetes}
              </Row>
            </Col>
            <Col xs={24} md={0}>
              <Row justify="center">
                {ver_paquetes_movil}
              </Row>
            </Col>
              {/*<Col xs={24} md={12}>
              <p className='titulo_paquete inter'>PAQUETES GRUPALES</p>
            </Col>
            <Col xs={20} md={24}>
              <Row justify="center">
                {ver_paquetes_gurpales}
              </Row>
            </Col>*/}
            <Col xs={24}>
              <br />
              <p className='incluye_entrada'>Todas las entradas tienen acceso a: 8 conferencias, 1 panel, mesas cruzadas y coffee break continuo
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
      
      <Row>
        <Col id="acerca-de" name="#acerca-de" spen={24}>
          <AcercaDe idioma={idioma} />
        </Col>
      </Row>
      
    <Element name="#agenda" />
      <Row justify="center" align="middle" >
      <Col span={24} className="" id="agenda">
      <HashScroll hash="#agenda" position="center">

        <Agenda2 idioma={idioma}/>
       
        </HashScroll>
         
      </Col>
      </Row>
      <Element name="#conferencistas" />
      <Row id="conferencistas" justify="center" align="middle">
      
        <Col span={24}>
          <CarouselPonentes2 idioma={idioma}/>
        </Col>
      </Row>
     
      <Element name="#panel" />
      <Row justify="center" align="middle" >
      <Col span={0} className="" id="panel">
      <HashScroll hash="#panel" position="center">

        <CarouselPanel idioma={idioma}/>
        
        </HashScroll>
      </Col>
      </Row>
      <Row justify="center" align="middle">
        
        </Row>
        {/*<Modal
                visible={ver_modal} onCancel={() => { setVerModal(false); }}
                title={null}
                footer={null}
                closable={true}
                width="750px"
                className=""
                forceRender={true}>
                <Row justify={'center'}>
                  <Col span={22}>
                  <p className='agradecimiento_1'>Gracias por asistir al</p><br />
                  </Col>
                  <Col span={18}>
                  <img src={img_logo} style={{width:'100%'}} /><br /><br />
                  </Col>
                  <Col span={22}>
                  <p className='agradecimiento_2 color_verde'>¡Nos vemos en el 2026!</p><br />
                  </Col>
                </Row>
            </Modal>*/}
    </>
  );
}

export default Evento;